import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ReservationsTable} from './table/ReservationTable'
import {ReservationEditModal} from './Reservation-edit-modal/ReservationEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {ReservationsListHeader} from './header/ReservationListHeader'

const ReservationsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ReservationsListHeader />
        <ReservationsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <ReservationEditModal />}
    </>
  )
}

const ReservationsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ReservationsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ReservationsListWrapper}
